export default __webpack_public_path__ + "images/delete-border-icon.svg";